import React from "react";

const NavigationLogo = (props) => {
  const { handler } = props;
  return (
    <div className="pt-0 pb-0 offcanvas-header d-flex d-md-none align-items-center">
      <h5 className="offcanvas-title">
        <a href="/">
          <img
            alt="ASTM Logo"
            fetchpriority="high"
            width="196"
            height="58"
            decoding="async"
            data-nimg="1"
            className="h-8 w-auto"
            src="https://qa-www.astm.org/v3/assets/blt5eb0a2cb04534832/blt51067b24c158463a/67bc579b2242644871b3c818/ASTM-newLogo.svg?branch=qa_alias"
          />
        </a>
      </h5>
      <button
        type="button"
        className="close-btn btn-close ml-auto"
        aria-label="Close"
        onClick={handler}
      >
        ×
      </button>
    </div>
  );
};

export default NavigationLogo;
